import { createContext } from '@direct-frontend/modules-context';
import type { ENV } from '@adv-frontend/yastore-modules/types';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- иначе сильно разрастается контекст
import type { GetMerchRatingReturn } from '@/entities/merchRating';
import {
    type SettingsCompany,
    type SettingsDelivery,
    type SettingsFeatureFlags,
    type SettingsYandexPay,
    // eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- иначе сильно разрастается контекст
} from '@/entities/merchSetting';
import type { Account } from '../../api/account';

export interface RequestContext {
    platform: 'touch' | 'desktop';
    env: ENV;
    nonce: string;
    yandexPassportEnv: 'prod' | 'test';
    yandexMapGeoCoderAPIKey: string;
    yandexMapGeoSuggestAPIKey: string;
    yandexMapRouteAPIKey: string;
    account: Account;
    payboxHost: string;
    yaCounter: number;
    globalYaCounter: number;
    host: string;
    isExpressCheckout: boolean;
    expressCheckoutSource: string;
    requestId: string;
    signature: string;
    orderId: string;
    storeSlug: string;
    delivery: SettingsDelivery;
    company: SettingsCompany;
    yandexPay: SettingsYandexPay;
    featureFlags: SettingsFeatureFlags;
    merchanthRating?: GetMerchRatingReturn;
    traceId: string;
    isDigitalOrder: boolean;
}

export const { setContext: setRequestContext, getContext: getRequestContext } = createContext<RequestContext>({
    name: 'requestContext',
});
